import { Button } from "@rumble-it/common-components/components";
import { useAuth } from "react-oidc-context";

export const LogoutButton = () => {
  const auth = useAuth();

  return (
    <>
      <Button
        type="button"
        variant="greyLight"
        onClick={auth.signoutRedirect}
        disabled={false}
      >
        Uitloggen
      </Button>
    </>
  );
};

export default LogoutButton;
